import { Settings2 } from "lucide-react";

type IconProps = { className?: string };

export function ManualBrandIcon({ className }: IconProps) {
  return <Settings2 className={className} strokeWidth={2} aria-hidden />;
}
